
import { Options, Vue } from 'vue-class-component';
import ImageGallery from '@/components/image-viewer/ImageGallery.vue';
import NBaseBar from '@/uikit/bars/NBaseBar.vue';
import { NButton } from '@/uikit';
import NThumbnail from '@/uikit/thumbnail/NThumbnail.vue';
import { PhotoViewerController } from '@/components/photo-viewer/PhotoViewerController';
import { ImageGalleryItem } from '@/uikit/image-viewer/types';

@Options({
  name: 'PhotoViewer',
  components: { NThumbnail, NBaseBar, ImageGallery, NButton }
})
export default class PhotoViewer extends Vue {
  private showItems = false;

  get photoViewer() {
    return this.$photoViewer as PhotoViewerController;
  }

  get activeItemIndex() {
    return this.photoViewer.options.activeItemIndex;
  }

  set activeItemIndex(v: number) {
    this.photoViewer.options.activeItemIndex = v;
  }

  get items() {
    return this.photoViewer.options.items;
  }

  get thumbnails() {
    return this.items.map((v) => v.thumbnail);
  }

  get galleryItems() {
    return this.items.map((v) => {
      const { thumbnail, fullframe, ...galleryItem } = v;
      (galleryItem as ImageGalleryItem).src = fullframe;
      return galleryItem;
    });
  }

  handleClose() {
    this.$photoViewer.hide();
  }

  showItemFullframe(i: number) {
    this.activeItemIndex = i;
    this.showItems = false;
  }

  mounted() {
    this.$refs.root.focus();
  }
}
